"use client";

import React from "react";
import Link from "next/link";
import { usePathname, useSearchParams } from "next/navigation";
import cn from "classnames";

import type { ResourceComponent } from "../Resource/types";
import type { InternalArticle as InternalArticleType } from "../../../../types/content";

import styles from "./InternalArticle.module.scss";
import { Icon } from "../../../Icon/Icon";
import { useArticleModalStore } from "../../../../store/useArticleModalStore";

const InternalArticle: ResourceComponent<InternalArticleType> = ({
  resource,
  isPremium,
  layoutType,
}) => {
  const { openModal } = useArticleModalStore();
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const isNewsArticle = layoutType === "news";
  return (
    <>
      <div
        className={cn([
          styles.internalArticleContainer,
          layoutType && styles[layoutType],
        ])}
      >
        <div
          className={cn([
            styles.innerContainer,
            layoutType && styles[layoutType],
          ])}
        >
          <Link
            href={`/a/${resource.article_id}`}
            prefetch={false}
            onClick={() =>
              openModal(
                searchParams.size > 0
                  ? `${pathname}?${searchParams}`
                  : pathname,
              )
            }
          >
            <span
              className={cn([
                styles.titleText,
                isPremium && styles.premium,
                layoutType && styles[layoutType],
              ])}
            >
              {resource?.link_title?.trim()}
            </span>
            {!isNewsArticle && (
              <span className={cn(styles.caret)}>
                <Icon
                  variant="caretRight"
                  size="small"
                  className={cn([
                    styles.iconColor,
                    isPremium && styles.iconColorPremium,
                  ])}
                />
              </span>
            )}
          </Link>
        </div>
      </div>
    </>
  );
};

export { InternalArticle };
